import { observer } from 'mobx-react-lite';
import LogicBuilderHeader from './LogicBuilderHeader';
import type { LogicBuilderHeaderProps, LogicBuilderHeaderValueProps } from './types';

export type { LogicBuilderHeaderProps, LogicBuilderHeaderValueProps };
export default observer(LogicBuilderHeader); // MANUAL OVERRIDE
